import React from 'react';
import styles from '../Wyszukiwarka.module.css';



  export default function ZamowienieId({zamowienieId, setZamowienieId} ){

  return(
      <div  className={styles.colData_nr}>

      <label className={styles.labelData}> ID zam </label>
      <input className={styles.inputData} style={{width:"70px"}} type="text"
            value={zamowienieId}
            onChange={(event) => {
              const re = /^[0-9]+$/;
              if (event.target.value === '' || re.test(event.target.value)) {
              setZamowienieId(event.target.value);
              }
            }}></input>
    </div>
  );
}